import { render, staticRenderFns } from "./shopping-basket.vue?vue&type=template&id=48aca973"
import script from "./shopping-basket.vue?vue&type=script&lang=js"
export * from "./shopping-basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports